<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/doctor/index">我的课程</el-breadcrumb-item>
        <el-breadcrumb-item>{{ courseInfo.title }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ video_title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button size="small" class="reback" type="primary" icon="el-icon-refresh-left" @click="back()">返回
      </el-button>
    </el-col>
    <div class="content">
      <div class="col1 flex" v-loading="loading">
        <div class="flex-grow flex bg-w">
          <div id="playerContainer" style="height: 700px;width: 74%"></div>

          <div class="flex-shrink-0 bg-2A2D31 flex column" style="width:26%">
            <div class="w-full bg-26292C text-w flex">
              <div class="course-years flex-grow flex center alcenter ft16 cur_p border-b txt-888"
                :class="{ 'border-r': i < chapterlist.length - 1, 'border-b-0 text-white': currentYear === v.years }"
                v-for="(v, i) in chapterlist" :key="i" @click="changeYear(i)">{{ v.years }}年</div>
            </div>
            <div class="w-full bg-26292C pd10">
              <div class="ft14 txt-888 mb10">
                共{{ videoList.length }}讲，更新完成！</div>
              <div class="flex items-center h55 bg1 box-border pl15 pr15">
                <!-- <span class="text-w ft14">学习进度：</span> -->
                <div class="w161">
                  <el-progress :text-inside="true" :stroke-width="14" :percentage="progressPercentage">
                  </el-progress>
                </div>
                <span class="txt-888 ft14 ml10">已学 {{ courseInfo.listen }}，完成{{ courseInfo.listen_rang
                }}%</span>
              </div>
            </div>
            <div class="flex-grow pl10 pr10 pb10 text-w overflow-y-scroll h400">

              <div class="video-list flex column alcenter cur_p" :class="{ 'txt-3078FF': videoId === v.bjy_vid }"
                v-for="(v, i) in videoList" :key="i">

                <div class="nav_title" v-if="isFirstTeacher(v.teacher_name, i)">
                  <div class="bigTitle pl10">
                    {{ v.teacher_name }}
                  </div>
                  <div class="bigTotal">共11节</div>
                </div>

                <div class="flex space col1" @click="nextPlayer(v.id)">
                  <div class="flex-grow flex">
                    <!-- <div class="w28 ft14">{{ i + 1 }}.</div> -->
                    <div class="ft14">{{ v.title }}</div>
                  </div>
                  <div class="flex-shrink-0 ft14 ml20" style="width: 50px;">
                    <div class="flex alcenter" v-if="videoId === v.bjy_vid">
                      <!-- <span class="txt-3078FF">播放中</span> -->
                      <img class="w14 ml5" src="../../../public/images/icon/24.gif" alt="">
                    </div>
                    <span v-else>{{ v.duration }}</span>
                  </div>
                </div>
                <div class="flex space col1 upview" v-if="v.jump_time > 0">
                  上次观看到：{{ v.jump_time_str }}
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: 0,
      video_id: 0,
      videoId: "",
      currentYear: 0,
      courseInfo: {
        listen_rang: 0,
      },
      chapterlist: [],
      videoList: [],
      teacherInfo: [],
      playerNew: "",
      video_title: "",
      idx: 0,
      currentIdx: 0,
      vTime: 0,
      timer: "",
      player: "",
      jump_time: 0,
      next_vid: 0,
      pack_id: 0,
      ids: 0,
    };
  },
  computed: {
    progressPercentage() {
      const value = Number(this.courseInfo && this.courseInfo.listen_rang);
      if (!Number.isFinite(value)) {
        return 0;
      }
      return Math.min(100, Math.max(0, Math.floor(value)));
    },
  },
  methods: {

    // 判断当前项是否是该老师的第一个出现项
    isFirstTeacher(name, index) {
      // 查找该老师在数组中第一次出现的索引
      const firstIndex = this.videoList.findIndex((item) => item.teacher_name === name);
      // 只有当前索引等于第一次出现的索引时，才显示名字
      return index === firstIndex;
    },


    createPlayer() {
      const container = document.getElementById("playerContainer");
      if (!container || !window.BjcPlayer || !this.videoList.length) return;
      if (this.idx >= this.videoList.length) this.idx = 0;

      const video = this.videoList[this.idx];
      const wrapper = document.createElement("div");
      wrapper.className = "bjc-player-wrapper";
      wrapper.style.width = "100%";
      wrapper.style.height = "100%";
      const videoElement = document.createElement("video");
      videoElement.className = "video video-js vjs-default-skin";
      videoElement.style.width = "100%";
      videoElement.style.height = "100%";
      videoElement.setAttribute("playsinline", "true");
      container.innerHTML = "";
      wrapper.appendChild(videoElement);
      container.appendChild(wrapper);

      this.player = new window.BjcPlayer(videoElement, {
        token: video.bjy_token,
        vid: video.bjy_vid,
        autoplay: true,
        currentTime: this.jump_time,
        playbackRates: [0.7, 1, 1.2, 1.5, 2],
        onplay: this.onPlayerPlay.bind(this),
        onpause: this.onPlayerPause.bind(this),
        ontimeupdate: this.onPlayerTimeUpdate.bind(this),
        onended: this.onPlayerEnded.bind(this),
        onerror: this.onPlayerError.bind(this),
      });
      this.idx++;
    },

    nextPlayer(vid) {
      let that = this;
      clearInterval(this.timer);
      var nums = this.getPlayerCurrentTime();
      this.disposePlayer();
      this.setCourseListen(nums);
      that.next_vid = 0;
      that.videoList.forEach(function (element, index) {
        if (vid == element.id) {
          that.videoId = element.bjy_vid;
          that.video_title = element.title;
          console.log(element.jump_time);
          console.log(element.times);
          if (element.jump_time >= element.times - 5) {
            that.jump_time = 0;
          } else {
            that.jump_time = parseInt(element.jump_time);
          }
          that.video_id = vid;
          that.idx = index;
          if (index < that.videoList.length - 1) {
            that.next_vid = that.videoList[index + 1]["id"];
          }
        }
      });
      console.log(that.next_vid);
      this.createPlayer();
    },
    getPlayerCurrentTime() {
      try {
        if (this.player && this.player.getCurrentTime) {
          return this.player.getCurrentTime() || 0;
        }
      } catch (e) {
        return 0;
      }
      return 0;
    },
    disposePlayer() {
      if (this.player && this.player.dispose) {
        this.player.dispose();
      }
      this.player = null;
    },
    onPlayerPlay() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.vTime++;
      }, 1000);
    },
    onPlayerPause() {
      clearInterval(this.timer);
    },
    onPlayerTimeUpdate(data) {
      if (data && typeof data.currentTime === "number") {
        this.currentTime = data.currentTime;
      }
    },
    onPlayerEnded() {
      if (this.next_vid == 0) {
        this.$alert("已经是最后一节课了", "听课提示", {
          confirmButtonText: "确定",
          callback: (action) => { },
        });
      } else {
        this.nextPlayer(this.next_vid);
      }
    },
    onPlayerError(error) {
      console.error("BjcPlayer error", error);
    },

    changeYear(v) {
      this.currentIdx = v;
      this.videoList = this.chapterlist[v].video;
      this.currentYear = this.chapterlist[v].years;
    },

    /**
     * 保存听课记录
     */
    setCourseListen(nums) {
      let that = this;
      that.axios
        .post("/setCourseListen", {
          course_id: that.id,
          video_id: that.video_id,
          time: that.vTime,
          num: nums,
        })
        .then((res) => {
          that.vTime = 0;
          that.getList(2);
        });
    },

    /**
     * 获取列表
     */
    getDetail() {
      let that = this;
      that.axios
        .post("/getCourseDetails", { id: that.id, video_id: that.video_id })
        .then((res) => {
          if (res) {
            that.courseInfo = res.data;
          }
        });
    },
    /**
     * 获取列表
     */
    getList(type = 1) {
      let that = this;
      that.axios
        .post("/getYtkCourseVideo", { id: that.id })
        .then((res) => {
          const data = (res && res.data) || [];
          that.chapterlist = data;
          const currentChapter = data[that.currentIdx] || data[0] || {};
          that.videoList = currentChapter.video || [];
          that.currentYear = currentChapter.years || 0;
          if (type == 1) {
            that.videoList.forEach(function (element, index) {
              if (element.jump_time) {
                let h = parseInt((element.jump_time / 60 / 60) % 24);
                h = h < 10 ? "0" + h : h;
                let m = parseInt((element.jump_time / 60) % 60);
                m = m < 10 ? "0" + m : m;
                let s = parseInt(element.jump_time % 60);
                s = s < 10 ? "0" + s : s;
                element.jump_time_str = h + ":" + m + ":" + s;
              } else {
                element.jump_time_str = "00:00:00";
              }
              if (that.video_id == element.id) {
                that.videoId = element.bjy_vid;
                that.video_title = element.title;
                that.idx = index;
                if (element.jump_time >= element.times - 5) {
                  that.jump_time = 0;
                } else {
                  that.jump_time = parseInt(element.jump_time);
                }
                if (index < that.videoList.length - 1) {
                  that.next_vid = that.videoList[index + 1]["id"];
                }
              }
            });
            if (that.videoList.length > 0) {
              that.createPlayer();
            } else {
              that.loading = false;
            }
          } else {
            that.videoList.forEach(function (element) {
              if (element.jump_time) {
                let h = parseInt((element.jump_time / 60 / 60) % 24);
                h = h < 10 ? "0" + h : h;
                let m = parseInt((element.jump_time / 60) % 60);
                m = m < 10 ? "0" + m : m;
                let s = parseInt(element.jump_time % 60);
                s = s < 10 ? "0" + s : s;
                element.jump_time_str = h + ":" + m + ":" + s;
              } else {
                element.jump_time_str = "00:00:00";
              }
            });
          }
        })
        .catch(() => {
          that.chapterlist = [];
          that.videoList = [];
          that.loading = false;
        })
        .finally(() => {
          if (that.loading) {
            that.loading = false;
          }
        });
    },
    back() {
      if (this.pack_id) {
        this.$router.push({
          path: "/course/details",
          query: {
            id: this.id,
            pack_id: this.pack_id,
            ids: this.ids
          },
        });
      } else {
        this.$router.push({
          path: "/course/details",
          query: {
            id: this.id,
          },
        });
      }
    },
  },
  created() {
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var query = that.$route.query;
    if (query.course_id) {
      that.id = query.course_id;
      that.video_id = query.video_id;
      that.currentIdx = query.idx;
      that.getDetail();
      that.getList();
    }
    if (query.pack_id) {
      that.pack_id = query.pack_id;
      that.ids = query.ids;
    }
  },
  destroyed() {
    clearInterval(this.timer);
    var nums = 0;
    try {
      nums = this.getPlayerCurrentTime();
    } catch (e) {
      nums = 0;
    }
    console.log(nums);
    this.disposePlayer();
    this.setCourseListen(nums);
  },
};
</script>
<style scoped>
.nav_title {
  width: 100%;
  margin: 5px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #71767c;
  height: 42px;
  line-height: 42px;
  cursor: pointer;
  border-radius: 5px;
}

.bigTitle {
  font-size: 15px;
  color: #ffffff;
  line-height: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
}

.bigTotal {
  font-size: 12px;
  font-weight: bold;
  padding-right: 20px;
}

.bigTitle img {
  width: 20px;
  height: 20px;
  margin: 0 8px;
}

.upview {
  font-size: 12px;
  color: #969696;
}

.el-message-box__wrapper {
  z-index: 99999 !important;
}

.flex-grow {
  flex-grow: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.inline-block {
  display: inline-block;
}

.bg-2A2D31 {
  background-color: #2a2d31;
}

.bg-26292C {
  background-color: #26292c;
}

.txt-888 {
  color: #888;
}

.course-years {
  height: 42px;
  border: 1px solid #3b3b3b;
  color: #888;
}

.video-list {
  align-items: center;
  border-bottom: 1px solid #37393c;
  padding: 10px 0;
  line-height: 24px;
}

.video-list:hover {
  color: #3078ff;
}

.txt-3078FF {
  color: #3078ff;
}

*::-webkit-scrollbar {
  display: none;
}

.bg1 {
  background-image: url("../../../public/images/bg/3.png");
  background-size: cover;
}

.w28 {
  width: 24px;
}

.w14 {
  width: 14px;
}

.w161 {
  width: 125px;
}

.h10 {
  height: 10px;
}

.h55 {
  height: 55px;
  align-items: center;
}

.h400 {
  height: 400px;
}

.text-white {
  color: #ffffff !important;
}

.border-b-0 {
  border-bottom: none;
}

.overflow-y-scroll {
  overflow-y: scroll;
}
</style>
